/**
 * @fileoverview Authentication schemas for login and registration validation
 */

import { z } from '@hono/zod-openapi';

// Authentication schemas
export const LoginSchema = z
  .object({
    email: z.string().email('Invalid email address').openapi({
      description: 'User email address',
      example: 'user@example.com',
    }),
    password: z.string().min(6, 'Password must be at least 6 characters').openapi({
      description: 'User password (minimum 6 characters)',
      example: 'securepassword123',
    }),
  })
  .openapi('LoginRequest');

export const RegisterSchema = z
  .object({
    email: z.string().email('Invalid email address').openapi({
      description: 'Email address for the new account',
      example: 'newuser@example.com',
    }),
    password: z.string().min(6, 'Password must be at least 6 characters').openapi({
      description: 'Password for the new account (minimum 6 characters)',
      example: 'securepassword123',
    }),
    name: z.string().min(1, 'Name is required').openapi({
      description: 'Display name for the new user',
      example: 'John Doe',
    }),
  })
  .openapi('RegisterRequest');
